import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const SupplierValidationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--purchase']}>
    <Route index element={<Index />} />
  </SubRouter>
))
